export const ANONYMOUS_SURVEY_CLICK_THRESHOLD = 10

const DEVICE_ID_KEY = "bsedu.survey.deviceId"
const SECOND_MENU_CLICK_COUNT_KEY = "bsedu.survey.secondMenuClickCount"
const ANSWERED_KEY_PREFIX = "bsedu.survey.answered"
const DEFERRED_UNTIL_KEY_PREFIX = "bsedu.survey.deferredUntil"

export function getOrCreateSurveyDeviceId(storage, createId) {
  const currentDeviceId = storage.getItem(DEVICE_ID_KEY)
  if (currentDeviceId) {
    return currentDeviceId
  }

  const deviceId = createId()
  storage.setItem(DEVICE_ID_KEY, deviceId)
  return deviceId
}

export function incrementAnonymousSurveySecondMenuClick(storage) {
  const currentCount = getAnonymousSurveySecondMenuClickCount(storage)
  const nextCount = Number.isFinite(currentCount) ? currentCount + 1 : 1
  storage.setItem(SECOND_MENU_CLICK_COUNT_KEY, String(nextCount))
  return nextCount
}

export function getAnonymousSurveySecondMenuClickCount(storage) {
  const currentCount = Number.parseInt(storage.getItem(SECOND_MENU_CLICK_COUNT_KEY) || "0", 10)
  return Number.isFinite(currentCount) ? currentCount : 0
}

export function hasReachedAnonymousSurveyClickThreshold(storage) {
  return getAnonymousSurveySecondMenuClickCount(storage) >= ANONYMOUS_SURVEY_CLICK_THRESHOLD
}

export function isAnonymousSurveyAnswered(storage, surveyVersion) {
  if (!surveyVersion) {
    return false
  }
  return storage.getItem(answeredKey(surveyVersion)) === "Y"
}

export function markAnonymousSurveyAnswered(storage, surveyVersion) {
  if (!surveyVersion) {
    return
  }
  storage.setItem(answeredKey(surveyVersion), "Y")
}

export function deferSurveyUntilTomorrow(storage, surveyVersion, audienceKey, now = new Date()) {
  if (!surveyVersion || !audienceKey) {
    return
  }

  const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
  storage.setItem(deferredUntilKey(surveyVersion, audienceKey), toLocalDateString(tomorrow))
}

export function isSurveyDeferredToday(storage, surveyVersion, audienceKey, now = new Date()) {
  if (!surveyVersion || !audienceKey) {
    return false
  }

  const deferredUntil = storage.getItem(deferredUntilKey(surveyVersion, audienceKey))
  if (!deferredUntil) {
    return false
  }

  return toLocalDateString(now) < deferredUntil
}

function answeredKey(surveyVersion) {
  return `${ANSWERED_KEY_PREFIX}.${surveyVersion}`
}

function deferredUntilKey(surveyVersion, audienceKey) {
  return `${DEFERRED_UNTIL_KEY_PREFIX}.${surveyVersion}.${audienceKey}`
}

function toLocalDateString(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, "0")
  const day = String(date.getDate()).padStart(2, "0")
  return `${year}-${month}-${day}`
}
